$(document).ready(function() {
	$("#header .togglemenu").click(function() {
		$(".mobile-menu").toggleClass("open")
	}), $(".mobile-menu .closemenu").click(function() {
		$(".mobile-menu").removeClass("open")
	}), $(".mobile-menu li.has-children .icon").click(function(e) {
		e.preventDefault(), $(this).toggleClass("active"), $(this).next("ul").fadeToggle()
	}), AOS.init({
		duration: 1100,
		once: !0,
		offset: 10,
		delay: 0,
		disable: "mobile",
		easing: "ease-in-out-cubic"
	}), $(".hero-home .slider").slick({
		dots: !1,
		infinite: !0,
		slidesToShow: 1,
		adaptiveHeight: !0,
		slidesToScroll: 1,
		arrows: !1,
		fade: !0,
		autoplay: !0,
		autoplaySpeed: 4e3,
		responsive: [{
			breakpoint: 992,
			settings: {
				dots: !0
			}
		}]
	}), $(".image-slider").slick({
		dots: !1,
		infinite: !0,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: !1,
		fade: !0,
		autoplay: !0,
		adaptiveHeight: !0,
		autoplaySpeed: 3e3
	}), $(".testimonial-carousel .slider").slick({
		dots: !1,
		infinite: !0,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: !1,
		autoplay: !0,
		autoplaySpeed: 6e3,
		adaptiveHeight: !0
	}), $(".testimonial-carousel .next").click(function() {
		$(".testimonial-carousel .slider").slick("slickNext")
	}), $(".product-slider").slick({
		dots: !1,
		infinite: !1,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: !1,
		autoplay: !1,
		responsive: [{
			breakpoint: 768,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				arrows: !0
			}
		}]
	}), $(".overview .main-slider").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: !1,
		arrows: !1,
		fade: !0,
		asNavFor: ".overview .thumbnail-slider",
		adaptiveHeight: !1
	}), $(".overview .thumbnail-slider").slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		asNavFor: ".overview .main-slider",
		dots: !1,
		arrows: !1,
		focusOnSelect: !0
	}), $(".section-more-products .slider").slick({
		slidesToShow: 4,
		slidesToScroll: 4,
		dots: 0,
        autoplay:1,
        responsive: [{
			breakpoint: 992,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
				arrows: 0,
				dots: !0
			}
		}]
    }), $(".accordion .item .heading").click(function() {
		$(this).parent().attr("data-item"), $(this).parent().toggleClass("active"), $(this).parent().find(".content").slideToggle()
	}), $(".read-more a").click(function(e) {
		e.preventDefault(), $(this).parent().parent().find(".hidden-content").slideToggle(), "Read More" == $(this).text() ? $(this).text("Read Less") : $(this).text("Read More")
	}), $(".toggle-table thead").click(function() {
		$(this).toggleClass('active');
		var $table = $(this).closest(".toggle-table");
		var $tbody = $table.find("tbody");

		// Use stop() to prevent animation stacking
		$tbody.stop(true, true).animate({
			height: 'toggle',
			opacity: 'toggle'
		}, {
			duration: 400,
			specialEasing: {
				height: 'swing',
				opacity: 'linear'
			}
		});
	})
}), $(window).scroll(function() {
	AOS.init(), $(window).scrollTop() >= 10 ? $("#header").addClass("active") : $("#header").removeClass("active")
});